import { combineReducers } from 'redux'
import { getOrNull } from '../../utils/selectors'

import injectReducer from '../../state/hoc/injectReducer'
import { createRequestingReducer, createErrorReducer, createSuccessReducer } from '../../utils/reducer'
import { switchLocaleRoutine } from './routines'

const { REQUEST, FULFILL, SUCCESS, FAIULRE } = switchLocaleRoutine
export const REDUCER_KEY = 'intl'

const messagesHandler = (state, { payload }) => ({ ...payload.messages })
const formatsHandler = (state, { payload }) => ({ ...payload.formats })
const localeHandler = (state, { payload }) => getOrNull('locale')(payload)

export const requesting = createRequestingReducer(REQUEST, FULFILL)
export const error = createErrorReducer(FAIULRE, REQUEST)
export const messages = createSuccessReducer(SUCCESS, FAIULRE, {}, messagesHandler)
export const formats = createSuccessReducer(SUCCESS, FAIULRE, {}, formatsHandler)
export const locale = createSuccessReducer(SUCCESS, FAIULRE, null, localeHandler)

const reducer = combineReducers({
  requesting,
  error,
  messages,
  formats,
  locale
})

export const withReducer = injectReducer({ key: REDUCER_KEY, reducer })
export default reducer
